import { TmElement } from '../custom-element.helper';

interface ScrollConfig {
  element: TmElement;
  scrollElement: HTMLElement;
}

export class ScrollToEndManager {
  private config: ScrollConfig;

  private boundScrollHandler: (event: Event) => void;

  constructor(config: ScrollConfig) {
    this.config = config;
    this.boundScrollHandler = this.handleScroll.bind(this);
  }

  private handleScroll(event: Event): void {
    const target = event.target as HTMLElement;

    if (target.scrollHeight <= target.clientHeight) {
      return;
    }

    const scrollPos = target.scrollTop + target.clientHeight;

    const isAtBottom = target.scrollHeight - scrollPos <= 1;

    if (isAtBottom) {
      this.config.element.dispatchLocalEvent({
        element: this.config.element,
        eventName: 'scrolled-to-end',
      });
    }
  }

  public attach(): void {
    this.config.scrollElement.addEventListener(
      'scroll',
      this.boundScrollHandler,
    );
  }

  public detach(): void {
    this.config.scrollElement.removeEventListener(
      'scroll',
      this.boundScrollHandler,
    );
  }
}

// Helper functies voor backward compatibility
export const addScrollToEndListener = (
  scrollElement: HTMLElement,
  element: TmElement,
): ScrollToEndManager => {
  const manager = new ScrollToEndManager({ scrollElement, element });
  manager.attach();
  return manager;
};

export const removeScrollToEndListener = (
  manager: ScrollToEndManager,
): void => {
  manager.detach();
};
